const VARIANTS = {
  navy: { text: "text-navy", dot: "bg-royal" },
  white: { text: "text-white", dot: "bg-lime" },
  lime: { text: "text-navy", dot: "bg-lime" },
};

export const Logo = ({ variant = "navy", size = "md" }) => {
  const v = VARIANTS[variant];
  const main = size === "lg" ? "text-5xl" : "text-[1.7rem]";
  return (
    <span className={`inline-flex flex-col font-display leading-none ${v.text}`} data-testid="brand-logo">
      <span className={`${main} font-extrabold tracking-[-0.07em]`}>
        PRPO<span className={`ml-[0.06em] inline-block h-[0.2em] w-[0.2em] rounded-full ${v.dot}`} aria-hidden="true" />
      </span>
      <span className="mt-[0.3em] flex items-center gap-1.5 text-[0.56rem] font-bold tracking-[0.5em]">
        <span className="h-px w-5 bg-current opacity-60" aria-hidden="true" />
        LTD
      </span>
    </span>
  );
};
